import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { authApi } from '@/utilities/axios';
import { useAuthStore } from '@/modules/auth/store';
import { showToast } from '@/utilities/toast-handler';
import { formatTreeData } from '../../../../../utilities/json-formatter';

const PROPERTY_TYPE_URL = process.env.VUE_APP_API_VERSION + '/property-types';
export const usePropertyTypeStore = defineStore('propertyType', () => {
    const authStore = useAuthStore();
    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });

    //state
    const propertyType = ref({});
    const propertyTypes = ref([]);

    //getters
    const propertyTypesTree = computed(() => {
        return formatTreeData(propertyTypes.value);
    });

    // actions
    const fetchAllPropertyTypes = async () => {
        try {
            const response = await authApi.get(PROPERTY_TYPE_URL, {
                params: {
                    company_id: company_id.value,
                    paginate: false,
                },
            });
            if (response.statusCode === 200) {
                propertyTypes.value = response.data;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch propert type');
        }
    };
    return {
        //state
        propertyType,
        propertyTypes,

        //action
        fetchAllPropertyTypes,

        //getters
        propertyTypesTree,
    };
});
